import { api } from '../../lib/api';
import type {
  SubmitLeadRequest,
  SubmitLeadResponse,
  VerifyLeadRequest,
  VerifyLeadResponse,
  ResendLeadOtpRequest,
  ResendLeadOtpResponse,
} from '@pms/shared';

/**
 * Leads API — the storefront's first service-layer module. Thin axios wrappers
 * only; components never call axios directly (they go through hooks).
 * `api.baseURL` already includes `/v1/public`, so the path here is just `/leads`.
 */
export async function submitLead(payload: SubmitLeadRequest): Promise<SubmitLeadResponse> {
  const { data } = await api.post<SubmitLeadResponse>('/leads', payload);
  return data;
}

export async function verifyLead(payload: VerifyLeadRequest): Promise<VerifyLeadResponse> {
  const { data } = await api.post<VerifyLeadResponse>('/leads/verify', payload);
  return data;
}

export async function resendLeadOtp(payload: ResendLeadOtpRequest): Promise<ResendLeadOtpResponse> {
  const { data } = await api.post<ResendLeadOtpResponse>('/leads/resend', payload);
  return data;
}
